import {PlatformIntl} from '../../../infra/PlatformIntl';
import {REPORT_MAX_DAYS, exceedsReportPeriodLimit} from '../../../helpers/report';

// The period reaches the schema already resolved: every config turns the chosen preset into an
// absolute range before validating, so one rule on the object covers both presets and hand-picked
// ranges.
const periodLimit = {
    name: 'period-limit',
    test: ({startDate, endDate} = {}, context) => {
        if (!exceedsReportPeriodLimit(startDate, endDate)) return true;
        return context.createError({
            path: 'endDate',
            message: PlatformIntl.getInstance().formatMessage('reportPeriodLimit', {
                format: {days: REPORT_MAX_DAYS},
            }),
        });
    },
};

export const defaultReportValidation = (Yup) =>
    Yup.object().test(periodLimit).shape({
        device: Yup.array().test(
            'device-or-group',
            '${path} is required',
            (value, context) => {
                const hasDevice = !!value && value.length > 0;
                const hasGroup = context.parent.group != null;
                return hasDevice !== hasGroup;
            }),
        group: Yup.mixed().nullable(),
        period: Yup.string().required(),
        endDate: Yup.date().when('period', {
            is: 'dateToDate',
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.notRequired(),
        }),
        startDate: Yup.date().when((['period']), {
            is: 'dateToDate',
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.notRequired(),
        }),
    });

export const eventReportValidation = (Yup) => defaultReportValidation(Yup).shape({
    event: Yup.array().required(),
});

    export const summaryReportValidation = (Yup) => defaultReportValidation(Yup).shape({
        daily: Yup.boolean().default(false).defined(),
    });

// Snapshot reports have no period: the provider always returns the current state.
export const noPeriodReportValidation = (Yup) => defaultReportValidation(Yup).shape({
    period: Yup.string().notRequired(),
});
